// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3gSdc","errorLogs":"EditorFooter_errorLogs__2VlrE"};